import { ITEMS, type ItemId } from "../game/sim/backpack";

const outline = "[text-shadow:0_2px_0_var(--color-ink),1px_0_0_var(--color-ink),-1px_0_0_var(--color-ink),0_-1px_0_var(--color-ink)]";

/** A little picture per item: the board on edge, the gun, the scooter, the washer, the skates, the bike. */
const ICONS: Record<ItemId, string> = {
  board: "🛹",
  paintball: "🎨",
  scooter: "🛴",
  washer: "💦",
  skates: "🛼",
  bmx: "🚲",
};

/** The backpack's items on foot (#136), the one that's out lit up, with the buttons that switch and use it. Sits at the bottom centre, clear of the touch stick and buttons. */
export function PackStrip({ item, keys }: { item: ItemId; keys: string }) {
  return (
    <div className="flex flex-col items-center gap-1" aria-label="Backpack">
      <div className="flex gap-1.5">
        {ITEMS.map((it) => {
          const out = it.id === item;
          return (
            <div
              key={it.id}
              aria-current={out ? "true" : undefined}
              title={it.name}
              className={`flex h-11 min-w-11 items-center gap-1 rounded-xl border-4 px-2 text-xl ${
                out ? "border-highlight bg-ink/85" : "border-ink/70 bg-ink/40 opacity-70"
              }`}
            >
              <span aria-hidden>{ICONS[it.id]}</span>
              {out && <span className={`text-sm font-black uppercase italic text-white ${outline}`}>{it.name}</span>}
            </div>
          );
        })}
      </div>
      <div className={`text-xs font-bold text-white ${outline}`}>{keys}</div>
    </div>
  );
}
